import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  adminExportData,
  adminImportApply,
  adminImportBackup,
  adminInspectImport,
} from "@/lib/callables";

/**
 * As chaves deixam um cartão da página Dados saber que o outro está rodando
 * (`useIsMutating`): exportar no meio de uma troca levaria metade de cada lado,
 * e importar no meio de uma exportação também.
 */
export const EXPORT_MUTATION_KEY = ["data", "export"] as const;
export const IMPORT_MUTATION_KEY = ["data", "import"] as const;

/** Passo 1 da exportação: o servidor gera o ZIP (ver a página Dados). */
export function useExportData() {
  return useMutation({ mutationKey: EXPORT_MUTATION_KEY, mutationFn: () => adminExportData() });
}

/** Lê e confere o ZIP enviado, sem gravar nada. */
export function useInspectImport() {
  return useMutation({ mutationFn: (path: string) => adminInspectImport({ path }) });
}

/** O backup obrigatório e, com ele, a troca dos dados pelos do ZIP. */
export function useImportData() {
  const qc = useQueryClient();
  const backup = useMutation({ mutationKey: IMPORT_MUTATION_KEY, mutationFn: adminImportBackup });
  const apply = useMutation({
    mutationKey: IMPORT_MUTATION_KEY,
    mutationFn: adminImportApply,
    // A base inteira mudou, inclusive quando a importação falhou no meio:
    // toda tela relê o que mostra.
    onSettled: () => qc.invalidateQueries(),
  });
  return { backup, apply };
}
